export default __webpack_public_path__ + "static/media/BANNERS_330x330_COCHE_SEMANASANTA.df485122.webp";